<template>
  <n-layout embedded content-style="padding: 12px;" class="card">
    <n-card style="min-height: 89vh" size="huge">
      <SlideSchedule></SlideSchedule>
    </n-card>
  </n-layout>
</template>
<script>
import SlideSchedule from '../components/SlideSchedule.vue';

import { defineComponent } from 'vue';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
export default defineComponent({
  name: 'SlideView',
  components: {
    SlideSchedule,
  },
  setup() {
    const store = useStore();
    const daySchedule = ref(
      computed(() =>
        JSON.parse(JSON.stringify(store.state.daySchedule)),
      ),
    );
    return {
      daySchedule,
    };
  },
});
</script>
<style scoped>
.carousel-img {
  width: 100%;
  height: 240px;
  object-fit: cover;
}
.card {
  background-color: #eaea7f;
  align-items: center;
  justify-content: center;
}
.container {
  display: flex;
  justify-content: center;
  flex-direction: row;
}
</style>
